import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@app/context/ModalsContext'

import { AuthSessionContext } from '@context/AuthContext'

import { getDateTimeFormat } from '@ui/v2/Table/cells/DateTime'
import { useTableColumns } from '@ui/v2/Table/hooks/useTableRows'
import { TableViewMoreModal } from '@ui/v2/Table/modals/TableViewMore.modal'

import { IntroducingBrokerReportDto } from '@model/IntroducingBrokerReportDto'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { IAppendableFetchQueryResult, SearchResponseProps } from '../IBReportResultsPage'
import { IBReportsTable } from '../IBReportsTable'
import { ReportColumn, ReportColumnCtx, reportColumns } from './IBReportsReportTable.columns'

export type IBReportsTableSortKeys =
  | 'login'
  | 'clientName'
  | 'email'
  | 'accountType'
  | 'registrationDate'
  | 'status'
  | 'balance'
  | 'volumeSince2019'
  | 'volumeCurrentMonth'
  | 'volumePreviousMonth'
  | 'swapFree'
  | 'clientEntity'
  | 'country'
  | 'currency'

interface IBReportsReportTableProps {
  data: IAppendableFetchQueryResult<IntroducingBrokerReportDto>
  search: SearchResponseProps
}

export const IBReportsReportTable: React.FC<IBReportsReportTableProps> = (props) => {
  const { data: reportSummary, search } = props

  const { t } = useTranslation()
  const { formatNumber, formatMoney } = useFormatNumber()

  const [auth] = useContext(AuthSessionContext)
  const rawDateFormat = auth?.dateFormatType?.name
  const dateFormat = getDateTimeFormat(rawDateFormat)

  const colsFormatCtx: ReportColumnCtx = { t, formatNumber, formatMoney, dateFormat }
  const ibReportViewMoreModal = useModal(TableViewMoreModal<IntroducingBrokerReportDto>)
  const data = reportSummary.query.data ?? []
  const { renderColumns } = useTableColumns<
    IntroducingBrokerReportDto,
    ReportColumnCtx,
    ReportColumn
  >({
    columns: reportColumns,
    formatCtx: colsFormatCtx,
    onArrowClick: (_, index) =>
      ibReportViewMoreModal.open({
        data,
        initialIndex: index,
        formatCtx: colsFormatCtx,
        columns: reportColumns,
      }),
  })

  return (
    <IBReportsTable
      tableQuery={reportSummary.query}
      sortOptions={search.sortOptions}
      renderColumns={renderColumns}
    />
  )
}
